import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderIpswitch extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
        this.cssClasses = {
            col: 'col-4 -xl-half -mb3',
            resourceWrapper: '-full -b1',
            resourceEmbed: 'Embed Embed--16by9 -db -tint-black -h-op-8',
            resourceImage: 'Section-bg -op-6',
            floatingLabel: 'Resource-floatingLabel Tag -tint-white -ttn',
            resourceContent: '-p2 -pt3 -pb3 -full -mt0 -df',
            labelWrap: '-fs0 -mb1',
            label: 'Tag',
            resourceDate: '-fs14 -fw3 -mb2',
            resourceLink: '-fs14 -ttu -fw5 -c-red -tdn'
        }

        this.minLabel = { en: 'min', de: 'minuten', nl: 'minuten', es: 'minutos', pt: 'minutos', fr: 'minutes', sv: 'minuter', jp: '分', 'zh-TW': '分' };
    }

    getResourceCtaLabel(contentType) {
        const lang = this.filterService.getSelectedLanguage();

        const learnMoreLabel = { en: 'Learn more', de: 'Mehr erfahren', nl: 'Meer informatie', es: 'Más información', pt: 'Saiba mais', fr: 'En savoir plus', sv: 'Läs mer', jp: '詳細', 'zh-TW': '深入瞭解' };
        const downloadTheReportLabel = { en: 'Download the report', de: 'Bericht herunterladen', nl: 'Download het rapport', es: 'Descargar el informe', pt: 'Baixar o relatório', fr: 'Télécharger le rapport', sv: 'Ladda ner rapporten', jp: 'レポートをダウンロード', 'zh-TW': '下載報告' };
        const downloadThePdfLabel = { en: 'Download the PDF', de: 'PDF herunterladen', nl: 'Download de PDF', es: 'Descargar el PDF', pt: 'Baixe o PDF', fr: 'Télécharger le PDF', sv: 'Ladda ner PDF:n', jp: 'PDF をダウンロード', 'zh-TW': '下載 PDF' };
        const viewTheInfographicLabel = { en: 'View the infographic', de: 'Hier die Infografik ansehen', nl: 'Bekijk de infographic', es: 'Ver la infografía', pt: 'Veja o infográfico', fr: 'Voir l\'infographie', sv: 'Visa infografiken' };
        const watchTheVideoLabel = { en: 'Watch the video', de: 'Sehen Sie sich das Video an', nl: 'Bekijk de video', es: 'Ver el vídeo', pt: 'Assista ao vídeo', fr: 'Regarder la vidéo', sv: 'Titta på videon', jp: 'ビデオを視聴', 'zh-TW': '觀看影片' };
        const registerLabel = { en: 'Register', de: 'Registrieren', nl: 'Registreer', es: 'Regístrese en', pt: 'Registre-se', fr: 'S\'inscrire', sv: 'Registrera', jp: '登録申し込み', 'zh-TW': '註冊網絡研討會' };
        const watchTheWebinarLabel = { en: 'Watch the webinar', de: 'Webinar ansehen', nl: 'Bekijk het webinar', es: 'Ver el seminario web', pt: 'Assista ao webinar', fr: 'Regarder le webinaire', sv: 'Se webbseminariet', jp: 'ウェビナーを視聴', 'zh-TW': '觀看網絡研討會' };
        const downloadLabel = { en: 'Download', de: 'Herunterladen', nl: 'Download', es: 'Descargar', pt: 'Download', fr: 'Télécharger', sv: 'Ladda ner', jp: 'ダウンロード', 'zh-TW': '下載' };

        switch (contentType.Id) {
            case '95d3ec8e-65be-4005-bbbf-cf94764bec84': // Live webinar
                return registerLabel[lang];
            case 'ba3505a5-edf2-4b48-8196-3cd4ec03e8b3': // On-demand webinar
                return watchTheWebinarLabel[lang];
            case 'c5dbf402-5020-4c9f-a6e5-80fbc168e2e8': // Video
                return watchTheVideoLabel[lang];
            case 'fba60918-8c88-4d01-afc9-63a9c113f644': // Analyst report
                return downloadTheReportLabel[lang];
            case 'eeb3c6b5-1f50-4737-a2f3-717e59683ec2': // Data sheet
                return downloadThePdfLabel[lang];
            case '3db61f70-a14e-4431-8aef-2d9fd62ba222': // Infographic
                return viewTheInfographicLabel[lang];
            case '70ae4793-8040-4c66-8bdf-0a7f4e81ede7': // Best practice
            case '6e38772a-82c5-454a-b6e6-740504dce161': // Case study
                return learnMoreLabel[lang];
            case 'fd8805fa-9232-4470-892e-e2e2bb263842': // Whitepaper
            case '63a9b7cc-0814-4876-8a8f-d77bd1451ddd': // Ebook
                return downloadLabel[lang];
            default:
                return this.CTAText;
        }
    }

    getItemHtml(item, relatedMedia) {
        let formattedDate = null;

        let { col, resourceWrapper, resourceEmbed, resourceImage, floatingLabel, resourceContent, labelWrap, label,  resourceDate, resourceLink} = this.cssClasses;
        const { imageData, fileData } = super.setRelatedMedia(item, relatedMedia);
        const { Title, CTAText, UrlName: resourcePath } = item;
        const contentType = item.resourceCategory[0];
        const pageUrl = super.getResourceUrl(item.contenttypes[0]);
        const resourceUrl = `${pageUrl}/${resourcePath}`;
        const featuredLabel = Boolean(Number(item.IsFeatured)) ? '<span class="Tag -pa -z1 -ml2 -tint-yellow -c-darkestgrey">Featured</span>' : '';
        const selectedLanguage = this.filterService.getSelectedLanguage();

        // Live Webinar Start Date
        if (contentType.Id === '95d3ec8e-65be-4005-bbbf-cf94764bec84' && item.StartDate !== null) {
            let startDate =  item.StartDate;
            let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            let webinarDate  = new Date(startDate);
            formattedDate = webinarDate.toLocaleDateString(selectedLanguage, options);
        }

        // Video Play Icon
        if (contentType.Id === 'c5dbf402-5020-4c9f-a6e5-80fbc168e2e8') {
            resourceEmbed += ' -i-play-lite -i--overlay -fs70 -accent-white';
        }

        const html = `
        <div class="${col}">
            <div class="${resourceWrapper}">
                <a href="${resourceUrl}" class="${resourceEmbed}">
                    ${featuredLabel}
                    <div class="${resourceImage}">
                        ${imageData && imageData.Url ? `<img src="${imageData.Url}" alt="${imageData.AlternativeText}">` : ''}
                    </div>
                    ${!item.VideoLength ? '' : `<div class="${floatingLabel}">${item.VideoLength}${this.minLabel[selectedLanguage] || this.minLabel.en}</div>`}
                </a>
                <div class="${resourceContent}">
                    <div class="${labelWrap}">
                        <div class="${label}">${contentType.Title}</div>
                    </div>
                    <div class="h4 ${formattedDate != null ? '-mb0' : ''}">${this.encodeHtml(Title)}</div>
                    <div class="${resourceDate}">${formattedDate != null ? formattedDate : ''}</div>
                    <a href="${fileData == null ? resourceUrl : fileData.Url}" class="${resourceLink}">${this.encodeHtml(this.getResourceCtaLabel(contentType) || CTAText)}</a>
                </div>
            </div>
        </div>
        `;

        return html;
    }
}